import { render, staticRenderFns } from "./MembersTab.vue?vue&type=template&id=2b239962&scoped=true"
import script from "./MembersTab.vue?vue&type=script&lang=ts"
export * from "./MembersTab.vue?vue&type=script&lang=ts"
import style0 from "./MembersTab.vue?vue&type=style&index=0&id=2b239962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b239962",
  null
  
)

export default component.exports